import React from "react";
import SectionsHead from "../components/common/SectionsHead";
import TopProducts from "../components/product/TopProducts";

const Home = () => {
  return (
    <main>
      <section id="products" className="section">
        <div className="container">
          <SectionsHead heading="Wszystkie produkty" />
          <TopProducts />
        </div>
      </section>
    </main>
  );
};

export default Home;
